// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"1847":"e8c51a3b","6476":"88df6af5"}[chunkId] + "." + {"1847":"3bb1a491691c6b83","6476":"bdd29de07cdd6dc1"}[chunkId] + ".js";
};